/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig_sec";

export const useSecUsersStore = defineStore("secusers", {
  actions: {
    async usersListFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          "employeeNumber:contains": payload.employeeNumber,
          "nameTh:contains": payload.nameTh,
          "nameEn:contains": payload.nameEn,
          "email:contains": payload.email,
          "username:contains": payload.username,
          "userLevel": payload.userLevel,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/sec-svc/user/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async usersInfoFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/sec-svc/user/info/" + payload.uid;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async usersInfoByServiceFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/sec-svc/user/info/" + payload.uid;
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async sessionInfoFetch() {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/sec-svc/user/info";
          const response = http.get(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async usersAddFetch(payload) {
      const body = {
        groupUid: payload.groupUid,
        username: payload.username,
        employeeNumber: payload.employeeNumber,
        nameTh: payload.nameTh,
        nameEn: payload.nameEn,
        email: payload.email,
        userLevel: payload.userLevel,
        accountStatus: payload.accountStatus,
        version: payload.version
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/sec-svc/user/new";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async usersUpdateFetch(payload) {
      const body = {
        uid: payload.uid,
        groupUid: payload.groupUid,
        username: payload.username,
        employeeNumber: payload.employeeNumber,
        nameTh: payload.nameTh,
        nameEn: payload.nameEn,
        email: payload.email,
        userLevel: payload.userLevel,
        accountStatus: payload.accountStatus,
        version: payload.version
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/sec-svc/user/update";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async usersDeleteFetch(payload) {
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/sec-svc/user/delete/" + payload.uid;
          const response = http.delete(pathUrl);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async usersSetPasswordFetch(payload) {
      const body = {
        uid: payload.uid,
        groupUid: payload.groupUid,
        password: payload.password
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/sec-svc/user/creds/password/set";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },

    async usersSetPinFetch(payload) {
      const body = {
        uid: payload.uid,
        groupUid: payload.groupUid,
        pin: payload.pin
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/sec-svc/user/creds/pin/set";
          const response = http.put(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
